import React, { useContext } from "react";
import "./Header.scss";
import MyContext from "../Context/MyContext";
import { useLocation, useNavigate } from "react-router-dom";

const Header = () => {
  const { token, logintime, handleLogout, usertoken, openLogoutModal, } = useContext(MyContext);

  const Navigate = useNavigate();

  const location = useLocation();

  const All = [
    "/",
    "/my-works",
    "/profile",
    "/daily-work",
    "/team-works",
    "/projects",
    "/learning",
    "/work-completed",
    "/reports",
    "/queries",
    "/certificate",
    "/timeline",
    "/survey",
  ];

  if (!All.includes(location.pathname)) {
    return null;
  }

  return (
    <header>
      <div className="header-main">
        <div className="left">
          <h1>{token ? usertoken.name : "user not found"}</h1>
          <p>{token ? `last login: ${logintime}` : "not found"}</p>
        </div>

        <div className="right">
          {token ? (
            <button onClick={ openLogoutModal}>Logout</button>
          ) : (
            <button onClick={() => Navigate("/login")}>Login</button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
